export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/domains/paper_status/index.js